import gql from "graphql-tag";

export const GET_CURRENT_USER = gql`
    query {
        me {
            id
            name
            username
            email
            dob
            gitlab_id
            gitlab_token
            roles
            permissions
            enabled
            image_name
        }
    }
`

export const GET_ALL_USER = gql`
    query {
        users {
            id
            name
            username
            gitlab_id
            email
            dob
            gitlab_token
            enabled
            image_name
        }
    }
`

export const GET_ALL_ROLES = gql`
    query {
        roles {
            name
        }
    }
`
